import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Chayan Mondal </span>
            from <span className="purple"> West Bengal, India.</span>
            <br />
            I am currently pursuing my BTech from NIT ROURKELA.
            <br />
            {/* I have completed Integrated MSc (IMSc) in Maths and Computing at BIT
            Mesra.
            <br /> */}
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Drawing
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing  Guitar
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
          "Every step forward, no matter how small, brings you closer to your goals. Keep moving!"{" "}
          </p>
          <footer className="blockquote-footer">Chayan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
